import '@n8n/chat/dist/style.css';
import './custom-chat-styles.css';
import { createChat } from '@n8n/chat';

createChat({
	webhookUrl: 'https://akkahotels.app.n8n.cloud/webhook/a1c5f1aa-f853-40eb-a6ba-e5e445d57a02/chat',
	webhookConfig: {
		method: 'POST',
		headers: {}
	},
	target: '#n8n-chat',
	mode: 'window',
	chatInputKey: 'chatInput',
	chatSessionKey: 'sessionId',
	metadata: {},
	showWelcomeScreen: true,
	defaultLanguage: 'tr',
	initialMessages: [
		// "Merhaba! Ben AKKA Bonus Asistanınız.",
		// "Size puanlarınız, kampanyalar veya şifre işlemleri gibi konularda yardımcı olabilirim."
	],
	i18n: {
		en: {
			title: 'Welcome',
			subtitle: "",
			footer: 'Akka Hotels © 2025',
			getStarted: 'New Conversation',
			inputPlaceholder: 'Type your question..',
		},
		tr: {
			title: '', 
			subtitle: "",
			footer: 'Akka Hotels © 2025',
			getStarted: 'Yeni Sohbet Başlat',
			inputPlaceholder: 'Sorunuzu yazın...',
		},
		de: {
			title: '',
			subtitle: "",
			footer: 'Akka Hotels © 2025',
			getStarted: 'Neues Gespräch',
			inputPlaceholder: 'Geben Sie Ihre Frage ein...',
		},
		ru: {
			title: '',
			subtitle: "",
			footer: 'Akka Hotels © 2025',
			getStarted: 'Новый разговор',
			inputPlaceholder: 'Введите ваш вопрос...',
		}
	},
});

// DOM Manipülasyonu
setTimeout(() => {
  const targetContainer = document.querySelector('.chat-get-started');
  const textElementToMove = document.querySelector('.chat-header p[class*="title"]');

  // 1. Aşama: Mevcut subtitle metnini taşıma girişimi
  if (textElementToMove && targetContainer) {
    if (targetContainer.firstChild) {
      targetContainer.insertBefore(textElementToMove, targetContainer.firstChild);
    } else {
      targetContainer.appendChild(textElementToMove);
    }
    textElementToMove.style.textAlign = 'center';
    textElementToMove.style.marginBottom = '10px';
    textElementToMove.style.fontSize = '1rem';
    textElementToMove.style.order = '2'; 
  }

  // 2. Aşama: Yeni zengin karşılama içeriğini oluştur ve ekle
  if (targetContainer) {
    const contentAndButtonWrapper = document.createElement('div');
    contentAndButtonWrapper.className = 'welcome-content-button-wrapper';

    const customWelcomeDiv = document.createElement('div');
    customWelcomeDiv.className = 'custom-rich-welcome-content'; 
    customWelcomeDiv.style.textAlign = 'center'; 

    const welcomeHeading = document.createElement('h3');
    welcomeHeading.textContent = 'AKKA Bonus Asistanına Hoş Geldiniz!';
    welcomeHeading.style.marginTop = '0';
    welcomeHeading.style.marginBottom = '8px';

    const welcomeParagraph = document.createElement('p');
    welcomeParagraph.textContent = 'Aşağıdaki butona tıklayarak sohbete başlayabilirsiniz.';
    welcomeParagraph.style.fontSize = '0.9rem';
    welcomeParagraph.style.marginBottom = '15px'; 
    
    customWelcomeDiv.appendChild(welcomeHeading);
    customWelcomeDiv.appendChild(welcomeParagraph);
    contentAndButtonWrapper.appendChild(customWelcomeDiv);

    const getStartedButton = targetContainer.querySelector('button');
    if(getStartedButton) {
        getStartedButton.style.marginTop = '10px'; 
        contentAndButtonWrapper.appendChild(getStartedButton);
    }
    
    while (targetContainer.firstChild) {
        targetContainer.removeChild(targetContainer.firstChild);
    }
    targetContainer.appendChild(contentAndButtonWrapper);

    const socialIconsContainer = document.createElement('div');
    socialIconsContainer.className = 'social-icons-container';

    const socialIconsTitle = document.createElement('p');
    socialIconsTitle.className = 'social-icons-title';
    socialIconsTitle.textContent = 'Bize Diğer Kanallardan Ulaşabilirsiniz.';
    socialIconsContainer.appendChild(socialIconsTitle);
    
    const iconsWrapper = document.createElement('div');
    iconsWrapper.className = 'icons-actual-wrapper';

    const instagramLink = document.createElement('a');
    instagramLink.href = 'https://www.instagram.com/akkahotels/';
    instagramLink.target = '_blank';
    instagramLink.rel = 'noopener noreferrer';
    const instagramIcon = document.createElement('img');
    instagramIcon.src = 'https://api.akkaportal.com/files/32719/images/e7223818-8da9-4980-a071-ace9f92b9e9c.png';
    instagramIcon.alt = 'Instagram';
    instagramLink.appendChild(instagramIcon);
    iconsWrapper.appendChild(instagramLink);

    const facebookLink = document.createElement('a');
    facebookLink.href = 'https://www.facebook.com/HotelsAkka/?locale=tr_TR';
    facebookLink.target = '_blank';
    facebookLink.rel = 'noopener noreferrer';
    const facebookIcon = document.createElement('img');
    facebookIcon.src = 'https://api.akkaportal.com/files/32719/images/0d1a969e-fcba-446c-9c5d-33016d736ed5.png';
    facebookIcon.alt = 'Facebook';
    facebookLink.appendChild(facebookIcon);
    iconsWrapper.appendChild(facebookLink);

    const telegramLink = document.createElement('a');
    telegramLink.href = 'https://t.me/akkachatbot';
    telegramLink.target = '_blank';
    telegramLink.rel = 'noopener noreferrer';
    const telegramIcon = document.createElement('img');
    telegramIcon.src = 'https://api.akkaportal.com/files/32719/images/6f82c2c3-3d6f-45c2-8360-1b2ad74f5e23.png';
    telegramIcon.alt = 'Telegram';
    telegramLink.appendChild(telegramIcon);
    iconsWrapper.appendChild(telegramLink);

    const mailLink = document.createElement('a');
    mailLink.href = 'mailto:peopleofakka@akkahotels.com';
    const mailIcon = document.createElement('img');
    mailIcon.src = 'https://api.akkaportal.com/files/32719/images/ddeac6a4-5da0-4539-8b56-a1ebe81e9e08.png';
    mailIcon.alt = 'Mail';
    mailLink.appendChild(mailIcon);
    iconsWrapper.appendChild(mailLink);

    socialIconsContainer.appendChild(iconsWrapper);

    targetContainer.appendChild(socialIconsContainer); 
    
    targetContainer.style.display = 'flex';
    targetContainer.style.flexDirection = 'column';
    targetContainer.style.alignItems = 'center';

  }
}, 1000);

// Ek DOM Manipülasyonu: Header içine logoyu <img> olarak ekleme ve ortalama
setTimeout(() => {
  const header = document.querySelector('.chat-layout .chat-header');

  if (header) {
    header.innerHTML = '';

    const logoImg = document.createElement('img');
    logoImg.src = 'https://cdn.akkahotels.com/Uploads/Cms/logo.svg';
    logoImg.alt = 'Akka Hotels Logo';
    logoImg.style.width = '150px';
    logoImg.style.height = 'auto';
    logoImg.style.display = 'block';

    header.appendChild(logoImg);
  }
}, 1050);

// Yeni Sohbet Başlat sonrası .chat-inputs animasyonunu tetikleme
const chatContainer = document.getElementById('n8n-chat');

if (chatContainer) {
    const observer = new MutationObserver((mutationsList, observer) => {
        const chatLayout = chatContainer.querySelector('.chat-layout');
        const chatInputs = chatLayout ? chatLayout.querySelector('.chat-inputs') : null;

        if (chatInputs && !chatInputs.classList.contains('animate-inputs-entry')) {
            chatInputs.classList.add('animate-inputs-entry');
            // observer.disconnect(); // Animasyon sadece bir kez tetiklenecekse bu satır aktif edilebilir.
        }
    });

    observer.observe(chatContainer, { childList: true, subtree: true });
} 